
class QuotationApi {

    getNextNumber() {
        var url = apiUrl + 'quotations/next-number';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getQuotationStatus() {
        var url = apiUrl + 'quotations/states';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }
    // Updated method with filtering and pagination support
    getListByCurrentBusiness(params = {}) {
        console.log('getListByCurrentBusiness', params);
        var url = apiUrl + 'quotations/currentBusiness/';

        // Build query string from params
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.quotationNumber) queryParams.append('quotationNumber', params.quotationNumber);
        if (params.customerName) queryParams.append('customerName', params.customerName);
        if (params.status) queryParams.append('status', params.status);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);

        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }

        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Get summary statistics
    getSummaryByCurrentBusiness() {
        var url = apiUrl + 'quotations/currentBusiness/summary';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    // Keep the original method for backward compatibility
    getListByCurrentBusinessSimple() {
        var url = apiUrl + 'quotations/currentBusiness/';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }
    // getListByCurrentBusiness()
    // {
    //     var url = apiUrl + 'quotations/currentBusiness/';
    //     return api.call('get', url)
    //         .then(({ data }) => {
    //             return data
    //         });

    // }

    getListByCurrentTenant() {
        var url = apiUrl + 'quotations/currentUser/';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getList() {
        var url = apiUrl + 'quotations';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getItem(id) {
        var url = apiUrl + 'quotations/item/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    get(id) {
        var url = apiUrl + 'quotations/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        var url = apiUrl + 'quotations';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }

    updateState(data) {
        var url = apiUrl + 'quotations/state/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    update(data) {
        var url = apiUrl + 'quotations/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'quotations/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

     // Export quotation as PDF
     async exportToPDF(id) {
        try {
            const url = apiUrl + `quotations/${id}/export-pdf`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${auth.getToken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return response.blob();
        } catch (error) {
            console.error('Error exporting PDF:', error);
            throw error;
        }
    }

    // Download PDF helper method
    async downloadPDF(id, filename) {
        try {
            const blob = await this.exportToPDF(id);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename || `quotation_${id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return true;
        } catch (error) {
            console.error('Error downloading PDF:', error);
            return false;
        }
    }
}

export default QuotationApi;